<template>
    <a-modal
        :visible="visibleConversionPoint"
        title="Konversi Poin"
        @ok="ConversionPoint"
        @cancel="handleCancel"
        width="90%"
        :destroy-on-close="true"
        :footer="null">

        <AForm
            v-if="state.isForm"
            ref="formRef"
            class="myform"
            :model="form"
            :rules="state.rules"
            @finish="handleOk"
            :wrapper-col="{ span: 14 }"
            :scroll-to-first-error="true">

            <!-- rule name -->
            <AFormItem
                label="Nama Rule"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="rule"
                has-feedback>
                <AInput
                    style="width: 100%"
                    :disabled="form.edit_status"
                    placeholder="nama rule"
                    v-model:value="form.rule" />
            </AFormItem>

            <!-- produk -->
            <AFormItem
                label="Produk"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="product_id"
                has-feedback>
                <FilterProduct
                    style="width: 100%"
                    :disabled="form.edit_status"
                    v-model:value="form.product_id"
                    show-search/>
            </AFormItem>

            <AFormItem
                label="UOM Produk"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="product_uom"
                has-feedback>
                <ASelect
                    v-if="form.product_id.length > 1 || form.edit_status"
                    class="mr-2"
                    v-model:value="form.product_uom"
                    show-search
                    allow-clear
                    placeholder="Pilih Produk UOM"
                    :disabled="form.edit_status"
                    style="width:100%;"
                    :options="state.product_uom_lists"
                />
                <FilterProductUom
                    v-else
                    style="width:100%;"
                    v-model:value="form.product_uom"
                    v-model:product_id="form.product_id"
                    :disabled="form.edit_status"
                    placeholder="uom produk"
                    :mode="null"
                    all/>
            </AFormItem>

            <AFormItem
                label="QTY"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="qty"
                has-feedback>
                <AInputNumber
                    placeholder="qty"
                    style="width: 100%"
                    :min="1"
                    :disabled="form.edit_status"
                    v-model:value="form.qty"
                    type="number"/>
            </AFormItem>

            <AFormItem
                label="Poin"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="point"
                has-feedback>
                <AInputNumber
                    placeholder="poin"
                    style="width: 100%"
                    :min="1"
                    type="number"
                    :disabled="form.edit_status"
                    v-model:value="form.point"/>
            </AFormItem>

            <AFormItem
                label="UOM Program"
                label-align="left"
                required
                name="point_uom_id"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }">
                <FilterLoyaltyUom
                    type="text"
                    style="width: 100%"
                    v-model:value="form.point_uom_id"
                    v-model:program="form.program_id"
                    :disabled="form.edit_status"
                    placeholder="uom program"
                    :mode="null"
                    all/>
            </AFormItem>

            <!-- tanggal -->
            <ARow class="form-row">
                <ACol :md="12" :sm="24">
                    <AFormItem
                        label="Tanggal Awal"
                        label-align="left"
                        :label-col="{ sm: { span: 8 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 } }"
                        name="start_date"
                        has-feedback>
                        <ADatePicker
                            v-model:value="form.start_date"
                            :disabled-date="disabledStartDate"
                            :disabled="form.edit_status"
                            format="DD MMMM YYYY"
                            value-format="YYYY-MM-DD"
                            style="width:100%"
                            placeholder="Pilih Tanggal"/>
                    </AFormItem>
                </ACol>
                <ACol :md="12" :sm="24">
                    <AFormItem
                        label="Tanggal Akhir"
                        label-align="left"
                        :label-col="{ sm: { span: 8 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 } }"
                        name="end_date"
                        has-feedback>
                        <ADatePicker
                            v-model:value="form.end_date"
                            :disabled-date="disabledEndDate"
                            :disabled="form.edit_status"
                            format="DD MMMM YYYY"
                            value-format="YYYY-MM-DD"
                            style="width:100%"
                            placeholder="Pilih Tanggal"/>
                    </AFormItem>
                </ACol>
            </ARow>

            <AFormItem
                label="Status"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                has-feedback>
                <ARadioGroup v-model:value="form.active" required>
                    <a-radio :value="1">Aktif</a-radio>
                    <a-radio :value="0">Non Aktif</a-radio>
                </ARadioGroup>
            </AFormItem>

            <!-- submit -->
            <ARow class="form-row mt-2">
                <ACol :sm="4"/>
                <ACol :sm="20">
                    <ASpace>
                        <AButton
                            type="primary"
                            html-type="submit"
                            :loading="form.busy"
                            :disabled="form.busy">{{
                                !form.edit_status ? 'Simpan' : 'Perbarui'
                            }}</AButton>
                        <AButton
                            title="Batal"
                            @click="state.isForm = !state.isForm; form.reset()">Batal</AButton>
                    </ASpace>
                </ACol>
            </ARow>

        </AForm>
        <div
            v-else
            class="row justify-content-end">
            <div class="col-auto">
                <ASpace>
                    <ATooltip
                        title="Tambahkan">
                        <AButton
                            @click="state.isForm = !state.isForm"
                            type="primary">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </AButton>
                    </ATooltip>
                    <ATooltip title="Download excel">
                        <DownloadExcel
                            :url="state.endpoint.current"
                            :params="state.params"
                            namefile="Konversi-Poin-Master-Program-Loyalty"
                            @errors="errorMessage"/>
                    </ATooltip>
                </ASpace>
            </div>
        </div>

        <div v-if="form.errors.any()">
            <ASpace>
                <AAlert
                    v-for="(item, index) in form.errors.all()"
                    type="error"
                    :key="index"
                    :message="item.message"
                    banner
                    closable
                    @close="form.clear()" />
            </ASpace>
        </div>

        <br>

        <ATable
            :data-source="state.data"
            :columns="state.columns"
            size="small"
            :pagination="{
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '50', '75'],
                showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} Hasil ${total} `,
                total: state.meta.total,
                pageSize: state.meta.per_page,
                current: state.meta.page,
            }"
            :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
            @change="handleTableChange"
            :loading="state.isFetching">
            <template #product="{ record }">
                <span
                    v-for="(item, index) in record.product"
                    :key="index">
                    <div class="row mb-2">
                        <div class="col-auto">
                            <p>{{ item.product_name }}</p>
                        </div>
                        <div class="col-auto ml-auto">
                            <ATooltip
                                :title="`Konversi Poin ${item.product_name}`">
                               <AButton
                                    @click="btnConversionLevelByProductList(item, record)"
                                   class="button"
                                   size="small">
                                   <i class="fe fe-list" />
                               </AButton>
                           </ATooltip>
                        </div>
                    </div>
                </span>
            </template>
            <template #action="{ record }">
                <span>
                    <a-tooltip title="Edit">
                        <a-button
                            class="button"
                            size="small"
                            :disabled="!record.is_edit"
                            @click="btnEdit(record)">
                            <i class="fe fe-edit" />
                        </a-button>
                    </a-tooltip>
                    <!-- <a-tooltip title="Hapus">
                        <a-button
                            class="button"
                            size="small"
                            @click="btnDelete(record.id)">
                            <i class="fe fe-trash" />
                        </a-button>
                    </a-tooltip> -->
                </span>
            </template>
        </ATable>


        <!-- detail konversi level by produk -->
        <ConversionLevelByProduct
            v-if="visibleConversionLevelByProductListModal"
            v-model:visible="visibleConversionLevelByProductListModal"
            v-model:item="visibleConversionLevelByProductListItemModal"/>
    </a-modal>
</template>
<script>
import {
    defineComponent,
    onMounted,
    reactive,
    ref,
} from 'vue'
import Form from 'vform'
import apiClient from '@/services/axios'
import { Modal, message } from 'ant-design-vue'
import FilterLoyaltyUom from '@/components/filter/FilterLoyaltyUom'
import FilterProduct from '@/components/filter/FilterProduct'
import FilterProductUom from '@/components/filter/FilterProductUom'
import DownloadExcel from '@/components/Molecules/DownloadExcel'
import moment from 'moment'
import { toInteger } from 'lodash'

import ConversionLevelByProduct from './ConversionLevelByProduct.vue'

export default defineComponent({
    components: {
        FilterLoyaltyUom,
        FilterProduct,
        FilterProductUom,
        DownloadExcel,
        ConversionLevelByProduct,
    },
    props: {
        visibleConversionPoint: [Boolean],
        model: {
            type: [Object],
            default: () => ({
                id: null,
            }),
        },
    },
    emits: ['handleOkConversionPoint', 'update:visibleConversionPoint'],
    setup(props, { emit }) {
        const form = reactive(new Form({
            program_id: props.model.record.id,
            rule: '',
            product_id: [],
            product_uom: '',
            qty: '',
            point: '',
            point_uom_id: '',
            active: 1,
            start_date: '',
            end_date: '',
            edit_status: false,
        }))

        const formRef = ref();

        const state = reactive({
            columns: [
                {
                    title: 'Nama Rule',
                    dataIndex: 'rule',
                },
                {
                    title: 'Produk',
                    slots: { customRender: 'product' },
                },
                {
                    title: 'UOM Produk',
                    dataIndex: 'product_uom_name',
                },
                {
                    title: 'QTY',
                    dataIndex: 'qty',
                },
                {
                    title: 'Poin',
                    dataIndex: 'point',
                },
                {
                    title: 'UOM Program',
                    dataIndex: 'point_uom_name',
                },
                {
                    title: 'Tanggal Mulai',
                    dataIndex: 'start_date',
                },
                {
                    title: 'Tanggal Akhir',
                    dataIndex: 'end_date',
                },
                {
                    title: 'Status',
                    dataIndex: 'status_active',
                },
                {
                    title: 'Action',
                    slots: { customRender: 'action' },
                },
            ],
            endpoint: {
                current: '/api/loyalty-point-conversions',
            },
            data: [],
            total: 0,
            isForm: false,
            isFetching: false,
            meta: {
                per_page: 10,
                page: 1,
                total: 0,
            },
            params: {
                program: props.model.record.id,
                page: 1,
                per_page: 10,
            },
            product_uom_lists: [
                {
                    label: "TON",
                    value: "ton",
                },
                {
                    label: "ZAK",
                    value: "zak",
                },
            ],
            rules: {
                rule: [
                    {
                        required: true,
                        message: "Nama rule tidak boleh kosong!",
                    },
                ],
                product_id: [
                    {
                        required: true,
                        message: "Produk tidak boleh kosong!",
                    },
                ],
                product_uom: [
                    {
                        required: true,
                        message: "UOM produk tidak boleh kosong!",
                    },
                ],
                qty: [
                    {
                        required: true,
                        message: "QTY tidak boleh kosong!",
                    },
                ],
                point: [
                    {
                        required: true,
                        message: "Poin tidak boleh kosong!",
                    },
                ],
                point_uom_id: [
                    {
                        required: true,
                        message: "UOM program tidak boleh kosong!",
                    },
                ],
                start_date: [
                    {
                        required: true,
                        message: "Tanggal mulai tidak boleh kosong!",
                    },
                ],
                end_date: [
                    {
                        required: true,
                        message: "Tanggal akhir tidak boleh kosong!",
                    },
                ],
            },
        })

        const handleTableChange = (page, filters, sorter) => {
            state.params.page = page.current
            state.params["per-page"] = page.pageSize

            fetchDataList()
        }

        const handleCancel = e => {
            emit('update:visibleConversionPoint', false)
        }

        const disabledStartDate = (current) => {
            return current && (current > moment(form.end_date) || current < moment(props.model.record.start_date, 'YYYY-MM-DD'))
        }

        const disabledEndDate = (current) => {
            return current && (moment(form.start_date) >= current || current >= moment(props.model.record.end_date, 'YYYY-MM-DD'))
        }

        const handleOk = async () => {
            if (form.product_id.length > 1) {
                form.product_uom_name = form.product_uom
            } else {
                form.product_uom_id = form.product_uom
            }

            // validation form
            await formRef.value.validate()
                .catch(() => {});

            if (!form.edit_status) {
                form.post(state.endpoint.current)
                    .then(response => {
                        if (response === undefined) {
                            errorMessage.value = `Kode error 500, No response from server`
                            return
                        }

                        message.success('Berhasil menyimpan')

                        fetchDataList()
                        form.reset()
                        formRef.value.resetFields()
                    })
            } else {
                form.put(`${state.endpoint.current}/${form.rule}`)
                    .then(response => {
                        if (response === undefined) {
                            errorMessage.value = `Kode error 500, No response from server`
                            return
                        }

                        message.success('Berhasil memperbarui')

                        fetchDataList()
                        form.reset()
                        formRef.value.resetFields()
                    })
            }

        }

        // Convert Point By Product - GET DATA
        const fetchDataList = () => {
            state.isFetching = true
            apiClient
                .get(state.endpoint.current, {
                    params: state.params,
                })
                .then(({ data }) => {
                    const { items, _meta } = data

                    state.data = items
                    state.meta.page = _meta.currentPage
                    state.meta.per_page = _meta.perPage
                    state.meta.total = _meta.totalCount
                })
                .finally(() => {
                    state.isFetching = false
                })
        }

        const btnDelete = id => {
            Modal.confirm({
                title: 'Konfirmasi hapus konversi poin',
                content: 'Apakah anda ingin hapus konversi poin?',
                onOk() {
                    apiClient
                        .delete(`${state.endpoint.current}/${id}`)
                        .then((response) => {
                            fetchDataList()
                            message.success('Berhasil dihapus')
                        })
                        .catch(e => message.error('Gagal menghapus!'))
                },
                onCancel() { },
            })
        }

        const btnEdit = (item) => {
            state.isForm = true
            formRef.value?.resetFields()
            form.clear()

            form.edit_status = true
            form.rule = item.rule
            form.product_id = item.product.map(item => item.product_id)
            form.product_uom = item.product_uom_name
            form.qty = item.qty
            form.point = item.point
            form.start_date = item.start_date
            form.end_date = item.end_date
            form.point_uom_id = item.point_uom_id
            form.active = toInteger(item.status_active_id)
        }

        // handle distributor list
        const visibleConversionLevelByProductListModal = ref(false);
        const visibleConversionLevelByProductListItemModal = ref(null);

        const btnConversionLevelByProductList = (item = null, parent = null) => {
            visibleConversionLevelByProductListModal.value = true
            visibleConversionLevelByProductListItemModal.value = {
                ...item,
                parent,
            }
        }

        // handle func vue
        onMounted(() => {
            fetchDataList()
        })

        return {
            formRef,
            disabledStartDate,
            disabledEndDate,
            btnDelete,
            btnEdit,
            handleOk,
            form,
            fetchDataList,
            state,
            handleCancel,
            handleTableChange,
            btnConversionLevelByProductList,
            visibleConversionLevelByProductListModal,
            visibleConversionLevelByProductListItemModal,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';
</style>
